import React, { Component } from "react";
import { connect } from "react-redux";
import { Spin } from "antd";
import ListRequete from "../../components/ListRequete";
import { columns } from "./columns";
import { loadRequetes } from "../../store/actions/requeteAction";

class Requetes extends Component {
  componentDidMount() {
    this.props.loadRequetes();
  }

  render() {
    const { requetes } = this.props;

    return (
      <Spin spinning={!requetes} size="large" tip="Chargement en cours...">
        <ListRequete
          listData={requetes && requetes.filter((item) => item.requete_fin === true)}
          tableOption={columns}
          addPanesRequete={this.props.addPanesRequete}
        />
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadRequetes: () => dispatch(loadRequetes()),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    requetes: state.requetes.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Requetes);
